import React from 'react';
import '../css/innonita.css';

const landingHTML = `<!DOCTYPE html>
<html lang="en">
    <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta name="description" content="" />
        <meta name="author" content="" />
        <title>INNOUNITA</title>
        <!-- Favicon-->
        <link rel="icon" type="image/x-icon" href="https://github.com/RaphaelCroitoriu/media-project/blob/main/assets/favicon.png?raw=true" />
        <!-- Core theme CSS (includes Bootstrap)-->
        <link href="https://bit.ly/3Exc98U" rel="stylesheet" />
		<!-- Custom theme CSS -->
        <link href="https://bit.ly/3iWDxpV" rel="stylesheet" />
		<!-- Google Fonts CSS -->
		<link rel="preconnect" href="https://fonts.googleapis.com">
		<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
		<link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap" rel="stylesheet">
    </head>
    <body>
        <!-- Responsive navbar-->
        <nav class="navbar navbar-expand-lg">
            <div class="container-fluid">
                <a class="navbar-brand" href="#"><img src="https://github.com/RaphaelCroitoriu/media-project/blob/main/assets/imgs/innounita-logo.png?raw=true" alt="INNOUNITA"></a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span class="navbar-toggler-icon"><img src="https://raw.githubusercontent.com/RaphaelCroitoriu/media-project/6302f0b3a35a9c7e7fdf9afc5ff626a2627e95a2/assets/imgs/hamburger.svg"></span></button>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                        <li class="nav-item"><a class="nav-link active" aria-current="page" href="#home">Home</a></li>
                        <li class="nav-item"><a class="nav-link" aria-current="page" href="#about">About Us</a></li>
						<li class="nav-item"><a class="nav-link" aria-current="page" href="#training">Training</a></li>
						<li class="nav-item"><a class="nav-link" aria-current="page" href="#database">Database</a></li>
						<li class="nav-item"><a class="nav-link" aria-current="page" href="#contacts">Get in touch</a></li>
                    </ul>
                </div>
            </div>
        </nav>
			
		
		<!-- Hero -->
		<section id="home">
			<div class="freccette">
				<a href="#project"><img src="https://github.com/RaphaelCroitoriu/media-project/blob/main/assets/imgs/freccia-giu.png?raw=true" alt="Scroll down" class="freccetta"></a>
			</div>	
			
		<div class="hero hero-home">
			<div class="hero-overlay home-overlay">
				<img src="https://github.com/RaphaelCroitoriu/media-project/blob/main/assets/imgs/home-elements_01.png?raw=true" class="float-start" alt="Graphic Element">
				<img src="https://github.com/RaphaelCroitoriu/media-project/blob/main/assets/imgs/home-elements_02.png?raw=true" class="float-end" alt="Graphic Element">	
			</div>
			
			<div class="container">
				<div class="row justify-content-center hero-block">
					<div class="col-xl-4 col-md-12 my-auto hero-content">
						
							<h1 class="big-title">INNOUNITA</h1>
								<p class="lead mb-4">
								INNOUNITA was born from a Consortium of 6 European universities, with the aim to help universities to develop their ability to innovate and improve technology transfer and capacity building. 
								</p>

								<a class="btn btn-primary" href="#contacts">
									Get in Touch
								</a>
			
					</div>
				</div>
        	</div>
			
		</div>
        </section>
		
		
		
		<!-- Project -->
		<section class="project" id="project">
			<div class="freccette">
				<a href="#top"><img src="https://github.com/RaphaelCroitoriu/media-project/blob/main/assets/imgs/freccia-su.png?raw=true" alt="Scroll down" class="freccetta"></a>
				<a href="#about"><img src="https://github.com/RaphaelCroitoriu/media-project/blob/main/assets/imgs/freccia-giu.png?raw=true" alt="Scroll down" class="freccetta"></a>
			</div>	
		
		<div class="container page-content">
			
            <div class="row ">
                <div class="col-lg-6 col-md-12 my-auto">
					<h2 class="big-title">Innounita</h2>
					<p class="lead mb-4">
					INNOUNITA is one of the winners of the pilot call launched in March 2020 by the European Institute of Innovation and Technology (EIT) called HEI Initiative: Innovation Capacity Building for Higher Education. This call is part of the EIT 2021-2027 strategy, as part of the Horizon Europe program of the European Commission, and aims to help universities develop the ability to innovate and teach innovation and entrepreneurship. More specifically, the initiative aims to encourage these institutions to look at their own practices and develop concrete actions to increase the impact on their ecosystems.
					</p>
				</div>
				
				<div class="col-lg-6 col-md-12">
					<img src="https://github.com/RaphaelCroitoriu/media-project/blob/main/assets/imgs/project-block-imgs.png?raw=true" alt="Graphic element">
				</div>
            </div>
        </div>
			
			
		</section>
		
		
		
		<!-- About -->
		<section id="about">
			<div class="freccette">
				<a href="#project"><img src="https://github.com/RaphaelCroitoriu/media-project/blob/main/assets/imgs/freccia-su.png?raw=true" alt="Scroll down" class="freccetta"></a>
				<a href="#training"><img src="https://github.com/RaphaelCroitoriu/media-project/blob/main/assets/imgs/freccia-giu.png?raw=true" alt="Scroll down" class="freccetta"></a>
			</div>	
		<div class="hero hero-about">

			<div class="container">
				<div class="row justify-content-center hero-block">
					<div class="col-xl-12 col-md-12 my-auto hero-content text-center">
						
					<h1 class="big-title about-title">About Us</h1>
					<div class="about-element"></div>
						<a class="btn btn-primary" href="/about">
						Discover More
						</a>
								
			
					</div>
				</div>
        	</div>

		</div>
		</section>
		
		
		<!-- training -->
		<section id="training">
			<div class="freccette">
				<a href="#about"><img src="https://github.com/RaphaelCroitoriu/media-project/blob/main/assets/imgs/freccia-su.png?raw=true" alt="Scroll down" class="freccetta"></a>
				<a href="#database"><img src="https://github.com/RaphaelCroitoriu/media-project/blob/main/assets/imgs/freccia-giu.png?raw=true" alt="Scroll down" class="freccetta"></a>
			</div>	
		<div class="hero hero-training">
			<div class="hero-overlay training-overlay">
				
			</div>
			
			<div class="container">
				<div class="row justify-content-center hero-block">
					<div class="col-xl-12 col-md-12 my-auto hero-content text-center">
						
					<h1 class="big-title training-title">Training</h1>
					<div class="training-element"></div>
						<a class="btn btn-primary" href="/training">
						Discover More
						</a>
							
			
					</div>
				</div>
        	</div>
			
		</div>
		</section>
		
		<!-- database -->
		<section id="database">
			<div class="freccette">
				<a href="#training"><img src="https://github.com/RaphaelCroitoriu/media-project/blob/main/assets/imgs/freccia-su.png?raw=true" alt="Scroll down" class="freccetta"></a>
				<a href="#contacts"><img src="https://github.com/RaphaelCroitoriu/media-project/blob/main/assets/imgs/freccia-giu.png?raw=true" alt="Scroll down" class="freccetta"></a>
			</div>	
		<div class="hero hero-database">
			<div class="hero-overlay database-overlay">
				
			</div>
			<div class="container">
				<div class="row justify-content-center hero-block">
					<div class="col-xl-12 col-md-12 my-auto hero-content text-center">
						
							<h1 class="big-title database-title">Database</h1>
							<div class="database-element"></div>
								<a class="btn btn-primary" href="/companies">
									Discover More
									</a>
					</div>
				</div>
        	</div>
			
		</div>
		</section>
		<div></div>
		
		<!-- contacts -->
		<section id="contacts">
			<div class="freccette">
				<a href="#database"><img src="https://github.com/RaphaelCroitoriu/media-project/blob/main/assets/imgs/freccia-su.png?raw=true" alt="Scroll down" class="freccetta"></a>			
			</div>	
		<div class="hero hero-contact">

			<div class="container">
				<div class="row justify-content-center hero-block">
					<div class="col-xl-6 col-md-12 my-auto hero-content">
						
							<h1 class="big-title contact-title">Get in Touch</h1>
							<div class="contacts-element"></div>
						
								<p>
								<a href="#">info@innounita.com</a>
								</p>
			
					</div>
					<div class="col-xl-2 col-md-2">
					</div>	
					<div class="col-xl-4 col-md-12 my-auto hero-content">
						
						<form>
							<input type="email" class="form-control" id="email" placeholder="Email">
							<input type="text" class="form-control" id="name" placeholder="Name">
							<input type="text" class="form-control" id="Surname" placeholder="Surname">	
							<textarea class="form-control" id="Message" rows="3"  placeholder="Message"></textarea>
						  	<button type="submit" class="btn btn-secondary float-end">Submit</button>
						</form>	
			
					</div>
				</div>
        	</div>
			
		</div>
		</section>
		
        <!-- Bootstrap core JS-->
        <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js"></script>
        <!-- Core theme JS-->
        <script src="https://bit.ly/3EWXWnf"></script>
    </body>
</html>
`;
const Landing = () => {
    return (
        <>
            {/* <header>
                <div className="head">
                    <h1>lorem ipsum,< br/> sit armert</h1>
                    <div>
                        <p>Integer posuere leo non erat ornare dictum id vitae magna. Proin consectetur iaculis nisi, ut convallis tortor tempor congue. Curabitur sit amet tempus felis. Duis tellus eros, pellentesque at rhoncus eu, maximus ut diam.</p>
                        <div><a className="contact" href="#">Contact Us</a></div>
                    </div>
                </div>
            </header>

            <main>
                <section className="intro">
                    <h2>About Us</h2>
                    <div>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque vel gravida nisi. Vestibulum ac consequat lorem. In in mi massa. Donec ut tellus sit amet sem ornare fermentum at et nunc. Pellentesque ac elementum metus. Praesent non venenatis lacus. In sagittis urna in nulla sagittis mattis.</p>
                    </div>
                </section>

                <div>
                    <div className="services">
                        <div className="service-one">
                            <p className="service-icon"><i className="far fa-calendar-alt"></i></p>
                            <p className="service-title">Planning</p>
                            <p>Mauris vitae turpis ut sem blandit consequat et at ligula. Suspendisse quam lectus, tristique dapibus sapien et, tempus suscipit nisl.</p>
                        </div>
                        <div className="service-two">
                            <p className="service-icon"><i className="fas fa-crop"></i></p>
                            <p className="service-title">Design</p>
                            <p>Nulla eu metus faucibus, vehicula tortor quis, venenatis odio. Nullam purus mauris, feugiat in odio vitae, posuere volutpat libero. Sed et convallis libero.</p>
                        </div>
                        <div className="service-three">
                            <p className="service-icon"><i className="fas fa-code"></i></p>
                            <p className="service-title">Development</p>
                            <p>Ut ornare vitae enim a rhoncus. Nullam aliquet tristique scelerisque. Sed volutpat dictum risus ac laoreet. Suspendisse id lorem in enim sollicitudin varius.</p>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="services">
                        <div className="service-one">
                            <p className="service-icon"><i className="far fa-calendar-alt"></i></p>
                            <p className="service-title">Planning</p>
                            <p>Mauris vitae turpis ut sem blandit consequat et at ligula. Suspendisse quam lectus, tristique dapibus sapien et, tempus suscipit nisl.</p>
                        </div>
                        <div className="service-two">
                            <p className="service-icon"><i className="fas fa-crop"></i></p>
                            <p className="service-title">Design</p>
                            <p>Nulla eu metus faucibus, vehicula tortor quis, venenatis odio. Nullam purus mauris, feugiat in odio vitae, posuere volutpat libero. Sed et convallis libero.</p>
                        </div>
                        <div className="service-three">
                            <p className="service-icon"><i className="fas fa-code"></i></p>
                            <p className="service-title">Development</p>
                            <p>Ut ornare vitae enim a rhoncus. Nullam aliquet tristique scelerisque. Sed volutpat dictum risus ac laoreet. Suspendisse id lorem in enim sollicitudin varius.</p>
                        </div>
                    </div>
                </div>

                <div className="gallery">
                    <div className="gallery-item-one"></div>
                    <div className="gallery-item-two"></div>
                    <div className="gallery-item-three"></div>
                    <div className="gallery-item-four"></div>
                    <div className="gallery-item-five"></div>
                    <div className="gallery-item-six"></div>  
                    <div className="gallery-item-seven"></div>  
                </div>

                <section>
                    <h2>Universities</h2>
                    <div>
                        <p>Integer sit amet venenatis erat. Cras elementum tortor odio, sit amet euismod nunc cursus ut. Donec sollicitudin orci sed enim volutpat, volutpat rutrum magna semper. Fusce leo lacus, pulvinar sit amet dignissim in, consectetur eget nulla. Etiam ac turpis augue. Sed tincidunt pulvinar tincidunt. Integer ac blandit magna. Nulla dapibus convallis luctus. </p>
                        <p>Ut elementum urna sit amet elit egestas hendrerit. Vivamus quis sem fringilla, tincidunt nisi non, congue libero. Etiam cursus nulla quis sapien varius, eget accumsan augue mattis. Cras accumsan sapien nulla, eu eleifend odio tempus sit amet. Suspendisse gravida hendrerit sapien, ut molestie mi pellentesque eget. Aliquam eleifend velit vel libero elementum, vitae consectetur nisl sollicitudin. Suspendisse volutpat fringilla vehicula.</p>
                    </div>
                </section>
            </main>

            <footer>
                <h3>Innounita</h3>
                <p>Support <br/> Support@supportme.com</p>
                <ul>
                    <li><a href="#"><i className="fab fa-facebook-f"></i></a></li>
                    <li><a href="#"><i className="fab fa-twitter"></i></a></li>
                    <li><a href="#"><i className="fab fa-instagram"></i></a></li>
                </ul>
            </footer> */}
            <div dangerouslySetInnerHTML={{ __html: landingHTML }} />;
        </>
    );
};

export default Landing;